<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/afXII6/tc-custom/9781429931991.jpg?1738254579875" alt="This image is the cover for the book Sand Dollars, John Caine"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sand Dollars, John Caine
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Award-winning author Charles Knief plots a spine-tingling read with a hair-raising payoff in this brilliant new mystery.</b><br/><br/>Still reeling from the tragic loss of his girlfriend and his treasured boat, retired U.S. Naval officer and private investigator John Caine returns to action when a wealthy San Diego woman hires him to investigate the death of her software mogul husband. From Hawaii to California to Mexico, Caine sets out to find what happened to Paul Peters-and the millions embezzled from his firm.<br/><br/>With the comely widow barely an arm's length away, Caine dives into a hotbed of Mexican justice, predatory sex, bullets and border politics to follow the money and find the truth.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charles Knief
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?56b3fbea